var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJbBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 86,
    viewBox: "0 0 81 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8457 23.1001V22.5671L2.05017 21.8511L37.7615 2.72656L78.9381 24.7786L78.1027 25.4071V25.9003",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0867 74.2285L78.1026 81.6428L37.7614 85",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1026 72.4952V64.8263L79.9323 63.7524V62.7977L37.7614 57.6348",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1027 61.0312V62.5746",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7614 9.85352L78.1026 29.2962",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9323 27.8178L37.7614 6.41016",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7614 5.00195L79.9323 26.8631V27.8177L78.1026 29.2974V44.1102",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84563 64.3093L1 63.1557V62.1375L37.7614 57.6348",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9324 63.7507L37.7614 59.0332L1 63.154",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7614 37.2751L39.4956 37.7524L40.6014 37.5297L78.9061 48.2295V47.2749L79.9323 45.6839V44.7292L40.6014 32.0803L39.4956 32.3985L37.7614 31.8496",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7614 35.9629L39.4956 36.4561L40.6253 36.1777L78.9061 47.2753",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7614 33.2031L39.4956 33.7361L40.6014 33.4497L79.9323 45.685",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8184 5.35134L48.0476 3.1875L43.0994 5.56613",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0475 1.90625L52.407 4.46785",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9539 4.96883L48.0476 1.90604L50.2751 1.04688L52.4071 4.46765L51.8184 5.35069V10.2432",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0475 8.23071V1.90625",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.761 8.78832L54.4437 6.87109L51.8423 8.03257",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4277 5.6543L58.3736 7.9852",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8423 6.84653L54.4278 5.65324L56.5439 4.8418L58.3736 7.98414L57.761 8.78762L57.7769 13.4415",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4277 5.6543L54.4516 11.6526",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4251 12.0573L60.1475 10.1719L57.7769 11.1902",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7769 10.0534L60.1475 9.01123L62.3352 8.16797L63.8865 11.2069L63.4251 12.0581V16.4653",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8866 11.2074L60.1476 9.01172",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1476 9.01172V14.7077",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5642 15.0166L65.4378 13.2188L63.449 13.9745",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4458 12.1211L68.97 14.1974",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.449 12.8857L65.2389 12.2016L67.4903 11.1992L68.9699 14.1984L68.5642 15.0178V19.2181",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4458 12.1211V17.5466",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2181 17.7055L70.3542 16.0508L68.5802 16.6713",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3542 14.9785L73.608 16.9117",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5802 15.6375L70.1792 15.0647L72.2555 14.0703L73.6079 16.9104L73.2181 17.7059V21.6994",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3542 14.9785V20.1654",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7998 5.30446L27.5706 3.14062L32.5108 5.51925",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5707 1.85938L23.2112 4.42098",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6247 4.90605L27.5707 1.85917L25.3352 1L23.2112 4.42077L23.7999 5.30381V10.1963",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5706 1.85938V8.14405",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8573 8.74144L21.1747 6.82422L23.7999 7.99364",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8414 13.3946L17.8573 8.74074L17.2448 7.93726L19.0745 4.79492L21.1826 5.60636L23.7999 6.81557",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1826 5.60547L17.2448 7.93637",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1826 5.60547L21.1587 11.6038",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1851 12.0104L15.4706 10.125L17.8413 11.1433",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8414 10.0065L15.4707 8.96435L13.283 8.12109L11.7317 11.16L12.1851 12.0112V16.4185",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7317 11.1586L15.4707 8.96289",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4707 8.96289V14.6589",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05396 14.9698L10.1724 13.1719L12.1692 13.9356",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1724 12.0742L6.64026 14.1426",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05395 19.1713V14.9709L6.63232 14.1515L8.11996 11.1523L10.1724 12.0752L12.1692 12.8468",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1724 17.4997V12.0742",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3413 22.0096L42.2721 21.6914L46.4804 23.4098",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1925 19.3298L45.4064 20.6901V15.193L42.1925 13.6895",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4064 33.6162V26.4008L42.1925 25.1836",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M48.875 25.0562L49.7501 24.7539L53.7118 26.3768",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6864 22.5036L52.7094 23.7844V18.5975L49.6864 17.1895",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7094 35.9646V29.1788L49.6864 28.0332",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8994 27.8567L56.7188 27.5703L60.4498 29.0977",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6552 25.4549L59.5031 26.6562V21.7875L56.6552 20.459",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5031 38.1598V31.7478L56.6552 30.6738",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3671 30.4502L63.1387 30.1797L66.655 31.6196",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M63.083 28.2076L65.7639 29.3372V24.747L63.083 23.498",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8117 40.1479L65.7639 34.1177L63.083 33.1074",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3018 32.8366L69.0337 32.582L72.359 33.9424",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M68.986 30.6814L71.5158 31.7713V27.4118L68.986 26.2344",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5158 42.0263V36.2985L68.986 35.3359",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8147 35.0728L74.5068 34.8262L77.49 36.0513",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4591 33.0289L76.8616 34.0472V29.9264L74.4591 28.8047",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8616 43.7045V38.3346L74.4591 37.4277",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2623 55.288V39.6797",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6475 39.2168V55.0478",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6474 70.7915C46.6474 69.996 47.1327 64.7773 43.9665 64.7773C41.0071 64.7773 41.2617 69.5028 41.2617 70.5449V84.7133",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6475 84.2595V74.3711",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2617 43.7682C41.2617 43.7682 41.7072 41.6123 43.5131 41.7635C45.653 41.9464 45.6689 44.4364 45.6689 44.4364V54.8976",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M54.889 56.2984V41.5254",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3538 41.0859V56.0657",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2704 45.2714C48.2704 45.2714 48.6682 43.2985 50.3865 43.4497C52.4151 43.6247 52.431 45.9795 52.431 45.9795V55.9236",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1897 57.2527V43.2832",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7339 42.877V57.0055",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8971 46.9187C54.8971 46.9187 55.2949 44.9776 56.9177 45.1208C58.8429 45.2879 58.8588 47.5074 58.8588 47.5074V56.8708",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1561 58.143V44.9531",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7799 44.5625V57.9592",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1976 48.3658C61.1976 48.3658 61.5715 46.5281 63.1149 46.6634C64.9366 46.8145 64.9446 48.9306 64.9446 48.9306V57.8326",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7646 59.0113V46.5215",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M71.468 46.1543V58.8112",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1403 49.7655C67.1403 49.7655 67.4983 48.0312 68.9461 48.1744C70.6645 48.3256 70.6724 50.3144 70.6724 50.3144V58.7152",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0867 59.8214V48.0078",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8536 47.6582V59.6309",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7726 51.0473C72.7726 51.0473 73.1067 49.4005 74.475 49.5199C76.1058 49.6631 76.1138 51.5485 76.1138 51.5485V59.5037",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2617 37.7148V54.23",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4956 37.7539V53.9588",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5874 72.535V72.3281L65.5094 72.4077V82.6939",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5476 83.0279L61.5794 74.293",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0703 70.5059L66.0185 70.6411",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4967 65.0715C64.2206 65.0317 64.8172 66.0102 64.8172 67.2512C64.8172 68.4923 64.2206 69.5105 63.4967 69.5265C62.7727 69.5424 62.2 68.5718 62.2 67.3467C62.2 66.1216 62.7807 65.1033 63.4967 65.0715Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7341 74.3478V73.2261L46.6395 70.7918L41.2697 70.6406L44.5631 73.1784V74.3637L49.7341 74.3478Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9299 66.082C43.3698 66.9173 43.3539 70.6961 43.3539 70.6961",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2704 74.3633V84.1244",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3856 70.9425C53.3856 70.2106 53.8549 65.2227 50.8399 65.2227C48.0316 65.2227 48.2703 69.7094 48.2703 70.7038V72.0801",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3936 83.7035V74.3242",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3291 74.3152V73.2492L53.3856 70.9342L48.2783 70.791L51.4127 73.2015V74.3311L56.3291 74.3152Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9067 66.4648C50.275 67.2604 50.2671 70.8562 50.2671 70.8562",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9049 74.3242V83.6001",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7658 71.1417C59.7658 70.4496 60.2033 65.748 57.3792 65.748C54.7142 65.748 54.9369 70.0041 54.9369 70.9508V72.168",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7657 83.1785V74.3242",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5499 74.2761V73.2896L59.7656 71.1098L54.9049 70.9746L57.8881 73.2657V74.2999L62.5499 74.2761Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5096 66.8926C56.8064 67.6881 56.7904 71.0293 56.7904 71.0293",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5316 71.4037C71.5316 70.7831 71.9214 66.543 69.3518 66.543C66.9652 66.543 67.1641 70.3695 67.1641 71.2207V82.5649",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5316 82.1994V74.2441",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0295 74.2445V73.3535L71.5236 71.4045L67.1641 71.2852L69.837 73.3297V74.2604L74.0295 74.2445Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7726 74.2598V82.0957",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8934 71.5471C76.8934 70.9584 77.2593 66.9648 74.8409 66.9648C72.5816 66.9648 72.7725 70.5686 72.7725 71.3721V72.3744",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8934 81.7541V74.2363",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2482 74.2279V73.3846L76.8855 71.539L72.7726 71.4355L75.2944 73.3607V74.2358L79.2482 74.2279Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8457 42.3908V26.6791L37.7615 9.8457",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8457 59.0018V46.4961",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8457 61.9143V60.2676",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8457 72.3355V64.3086",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8457 74.2754V82.0875L37.7615 84.9991",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0238 25.0574L37.7613 6.41016",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7613 5.00195L1.0238 24.0469V25.0572L2.84557 26.6801",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7615 60.8789L2.8457 64.3076",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7615 35.9629L36.0431 36.4482L34.9373 36.1618L2.05017 45.7081V46.7184L34.9373 37.5301L36.0431 37.7528L37.7615 37.2755",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7613 31.8496L36.043 32.3906L34.9372 32.0803L1.0238 42.9711V43.9894L2.05004 45.7077",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7613 33.2031L36.043 33.7361L34.9372 33.4418L1.0238 43.9905",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M34.285 21.9862L33.3542 21.668L29.1459 23.3863",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4178 13.6328L30.2118 15.1284V20.6494L33.4178 19.2731",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2118 33.5692V26.3617L33.4178 25.1445",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7354 25.0015L25.8603 24.6992L21.8986 26.3141",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9239 17.1328L22.9009 18.5409V23.7516L25.9239 22.4788",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9009 35.9157V29.1377L25.9239 27.9922",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7188 27.7857L18.8994 27.5391L15.1683 29.0665",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9552 20.3867L16.1151 21.7153V26.6396L18.9552 25.4304",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1151 38.1126V31.7165L18.9552 30.6426",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2511 30.379L12.4714 30.1562L8.9552 31.5882",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5192 23.4102L9.83826 24.6591L9.84621 29.2971L12.5112 28.1674",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84631 40.1086V34.0944L12.5272 33.0762",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30845 32.7818L6.60838 32.5352L3.56946 33.7841",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63232 26.1875L4.10254 27.3649V31.7403L6.63232 30.6663",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10254 41.9534V36.2653L6.63232 35.3027",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3479 55.2783V39.6621",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9708 39.1934V55.0323",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9548 70.7758C28.9548 69.9802 28.4695 64.7695 31.6357 64.7695C34.5951 64.7695 34.3405 69.487 34.3405 70.5371V84.7134",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9548 84.2683V74.3242",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3564 43.7592C34.3564 43.7592 33.9189 41.5954 32.1051 41.7545C29.9651 41.9374 29.9492 44.4274 29.9492 44.4274V54.8886",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7211 56.2889V41.5",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2565 41.0781V56.05",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3638 45.2392C27.3638 45.2392 26.958 43.2901 25.2477 43.4333C23.2111 43.6083 23.1952 45.971 23.1952 45.971V55.9152",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4286 57.2432V43.2578",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8843 42.8613V57.0217",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7292 46.9109C20.7292 46.9109 20.3314 44.9698 18.7085 45.113C16.7834 45.2721 16.7675 47.4996 16.7675 47.4996V56.8868",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46216 58.1511V44.9453",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83826 44.5391V57.9437",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4285 48.3573C14.4285 48.3573 14.0466 46.5197 12.5113 46.6469C10.6895 46.8061 10.6736 48.9222 10.6736 48.9222V57.8241",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14233 46.1465V58.8113",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46208 49.7577C8.46208 49.7577 8.11205 48.0234 6.66418 48.1666C4.94584 48.3098 4.92993 50.3066 4.92993 50.3066V58.6994",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3566 37.6895V54.2205",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M36.043 37.7539V53.9588",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8761 74.34V73.2183L28.9707 70.7681L34.3564 70.6328L31.047 73.1706V74.3479L25.8761 74.34Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7281 66.0742C32.2882 66.9095 32.3041 70.6883 32.3041 70.6883",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3638 74.3242V84.1092",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2248 70.9426C22.2248 70.2187 21.7713 65.2148 24.7784 65.2148C27.5866 65.2148 27.348 69.7016 27.348 70.696V72.0643",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2247 83.7035V74.3242",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2892 74.3068V73.2408L22.2247 70.9417L27.3479 70.8145L24.2056 73.2249V74.3148L19.2892 74.3068Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7114 66.4473C25.3431 67.2428 25.359 70.8624 25.359 70.8624",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7131 74.3242V83.5921",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8525 71.1419C15.8525 70.4498 15.4149 65.7402 18.2391 65.7402C20.9121 65.7402 20.6813 69.9963 20.6813 70.943V72.1681",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8525 83.1785V74.3242",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0602 74.2998V73.2895L15.8525 71.1017L20.7132 70.9824L17.7299 73.2656V74.3077L13.0602 74.2998Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1086 66.877C18.8119 67.6725 18.8278 71.0296 18.8278 71.0296",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46216 74.3242V82.5898",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09462 71.4117C4.09462 70.7912 3.69686 66.5352 6.26641 66.5352C8.653 66.5352 8.46207 70.3616 8.46207 71.2129V72.3505",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0946 82.1994V74.2441",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58069 74.2682V73.3613L4.09456 71.4043L8.45406 71.293L5.77313 73.3454V74.2762L1.58069 74.2682Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4047 74.3242V83.075",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86212 71.2616C9.86212 70.6093 9.44844 66.1543 12.1294 66.1543C14.6353 66.1543 14.4205 70.1319 14.4205 71.0388V72.2481",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86218 82.6773V74.3242",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22107 74.2849V73.3303L9.83836 71.2619L14.3967 71.1426L11.6044 73.2985V74.2929L7.22107 74.2849Z",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7614 55.4137L78.9061 61.1415V59.9482L37.7614 53.6953",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7615 55.4137L2.05017 60.3778V59.1288L37.7615 53.6953",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6865 29.8867L37.7613 29.2344L36.7908 29.5605",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M38.724 26.8146L37.7614 26.4805L35.8282 27.1248",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6865 24.4132L37.7613 23.6973L36.7908 24.0632",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7319 21.3096L37.7613 20.9277L35.8521 21.6676",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7024 18.9716L37.7613 18.1602L36.7908 18.5579",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7319 15.8124L37.7613 15.3828L35.8521 16.2181",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7024 13.5064L37.7613 12.6074L36.7908 13.0609",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7614 84.9684V2.72656",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1026 64.8247L37.7614 60.8789",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M42.105 33.9199V34.9621L41.214 36.3463",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7303 34.7305V35.7726L43.8711 37.1171",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2679 35.5176V36.504L46.4247 37.8564",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7501 36.2969V37.2595L48.9307 38.58",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1525 37.0371V37.9917L51.349 39.2805",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4674 37.7695V38.6923L53.7117 39.9652",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7586 38.4844V39.3833L55.9869 40.6323",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9781 39.1621V40.0531L58.2383 41.2782",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M61.134 39.8379V40.7368L60.426 41.9142",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2422 40.4902V41.3574L62.5342 42.5268",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2788 41.127V41.9941L64.5946 43.1237",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2834 41.748V42.6072L66.6232 43.7051",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2245 42.3516V43.171L68.5563 44.2767",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1258 42.9395V43.7589L70.4735 44.8249",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9953 43.5215V44.325L72.3589 45.3751",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8013 44.0859V44.8576L74.1808 45.8838",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5832 44.6426V45.4142L76.0104 46.4086",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3015 45.1758V45.9713L77.7367 46.9339",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8847 9.01172V10.4675L41.8982 11.8199",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0844 7.5957V9.00379L39.0343 10.4437",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5656 10.3789V11.8268L44.6189 13.1314",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0874 11.6523V13.0604L47.1407 14.3571",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5694 12.916V14.2684L49.6387 15.5492",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9958 14.1504V15.4869L52.0968 16.7359",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3347 15.3359V16.6804L54.4517 17.8896",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6337 16.5059V17.8026L56.7745 18.9879",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8453 17.627V18.9634L59.0338 20.0851",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0489 18.748V20.005L61.2295 21.1346",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1491 19.8066V21.1034L63.3695 22.1694",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2334 20.873V22.1061L65.4537 23.1721",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2302 21.8828V23.0761L67.4585 24.1342",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1712 22.8691V24.0704L69.4393 25.0887",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1282 23.8633V25.0486L71.4043 26.043",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M73.95 24.7949V25.8689L73.2102 26.9031",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7876 25.7246V26.8463L75.0955 27.8169",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5776 26.6309V27.7287L76.9014 28.6913",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4257 33.9102V34.9603L34.3167 36.3445",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8005 34.7305V35.7726L31.6597 37.1171",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2628 35.5176V36.504L29.1061 37.8564",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7806 36.2969V37.2595L26.608 38.58",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3782 37.0371V37.9917L24.1817 39.2805",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0632 37.7695V38.6923L21.819 39.9652",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7721 38.4844V39.3833L19.5438 40.6323",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5526 39.1621V40.0531L17.2925 41.2782",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3967 39.8379V40.7368L15.1047 41.9142",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2886 40.4902V41.3574L12.9966 42.5268",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2521 41.1191V41.9942L10.9362 43.1239",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24719 41.748V42.6072L8.90748 43.7051",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30627 42.3516V43.171L6.97452 44.2767",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40491 42.9395V43.7589L5.05724 44.8249",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5354 43.5215V44.325L3.17182 45.3751",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6461 9.01953V10.4674L33.6246 11.8118",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4463 7.60352V9.00365L36.4725 10.4197",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9652 10.3711V11.8269L30.9039 13.1157",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4434 11.6445V13.0606L28.3741 14.3334",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9613 12.9102V14.2705L25.8841 15.5354",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M22.527 14.1426V15.487L23.4259 16.7201",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1962 15.3281V16.6805L21.0792 17.8897",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8971 16.5059V17.8026L18.7483 18.98",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6854 17.6191V18.9636L16.4889 20.0614",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4818 18.7402V20.0051L14.3012 21.1268",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3896 19.8066V21.1034L12.1534 22.1534",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29736 20.8652V22.1063L10.069 23.1643",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30054 21.875V23.0763L8.06424 24.1263",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3595 22.8613V24.0705L6.08343 25.0809",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40247 23.8555V25.0488L4.11844 26.0352",
    stroke: "currentColor",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJbBuilding);
export default __webpack_public_path__ + "static/media/jb-building.9c676cb2c77177c098996b8c775ede16.svg";
export { ForwardRef as ReactComponent };